import { Route } from 'react-router-dom';

// Routes
import { NoAuthRouteKeys } from 'src/utils/constants/routes';

// Components
import NoAuthProvider from 'src/contexts/NoAuthContext';
import TradeDataPublicPage from 'src/features/Public/TradeData';
import CampaignProgramPage from 'src/pages/CampaignProgram';
import ForgotPasswordPage from 'src/pages/ForgotPassword';
import GeneralDisclaimerPage from 'src/pages/GeneralDisclaimer';
import LoginPage from 'src/pages/Login';
import AiHSCodeLabelingPublicPage from 'src/pages/Public/AiHSCodeLabeling';
import SinglePredictionPublicPage from 'src/pages/Public/AiHSCodeLabeling/SingleSearchResult';
import TariffsAndRulesPublicPage from 'src/pages/Public/TariffsAndRules';
import ResetPasswordPage from 'src/pages/ResetPassword';
import SignUpPage from 'src/pages/SignUp';
import TermAndConditionPage from 'src/pages/TermAndCondition';
import TradeDataLimitationsPage from 'src/pages/TradeDataLimitations';
import TwoStepVerificationPage from 'src/pages/TwoStepVerification';
import ProtectRoute from 'src/routes/ProtectRoute';

const NoAuthRoutes = [
  <Route
    key={NoAuthRouteKeys.Login}
    path={NoAuthRouteKeys.Login}
    element={
      <NoAuthProvider>
        <LoginPage />
      </NoAuthProvider>
    }
  />,
  <Route
    key={NoAuthRouteKeys.SignUp}
    path={NoAuthRouteKeys.SignUp}
    element={
      <NoAuthProvider>
        <SignUpPage />
      </NoAuthProvider>
    }
  />,
  <Route
    key={NoAuthRouteKeys.TwoStepVerification}
    path={NoAuthRouteKeys.TwoStepVerification}
    element={
      <NoAuthProvider>
        <ProtectRoute>
          <TwoStepVerificationPage />
        </ProtectRoute>
      </NoAuthProvider>
    }
  />,
  <Route
    key={NoAuthRouteKeys.ForgotPassword}
    path={NoAuthRouteKeys.ForgotPassword}
    element={
      <NoAuthProvider>
        <ForgotPasswordPage />
      </NoAuthProvider>
    }
  />,
  <Route
    key={NoAuthRouteKeys.ResetPassword}
    path={NoAuthRouteKeys.ResetPassword}
    element={
      <NoAuthProvider>
        <ProtectRoute>
          <ResetPasswordPage />
        </ProtectRoute>
      </NoAuthProvider>
    }
  />,
  <Route
    key={NoAuthRouteKeys.GeneralDisclaimer}
    path={NoAuthRouteKeys.GeneralDisclaimer}
    element={<GeneralDisclaimerPage />}
  />,
  <Route
    key={NoAuthRouteKeys.TermAndCondition}
    path={NoAuthRouteKeys.TermAndCondition}
    element={<TermAndConditionPage />}
  />,
  <Route
    key={NoAuthRouteKeys.AIHSCodeSearchPublic}
    path={NoAuthRouteKeys.AIHSCodeSearchPublic}
    element={<AiHSCodeLabelingPublicPage />}
  />,
  <Route
    key={NoAuthRouteKeys.AIHSCodeSearchResultPublic}
    path={NoAuthRouteKeys.AIHSCodeSearchResultPublic}
    element={<SinglePredictionPublicPage />}
  />,
  <Route
    key={NoAuthRouteKeys.TariffsAndRulesPublic}
    path={NoAuthRouteKeys.TariffsAndRulesPublic}
    element={<TariffsAndRulesPublicPage />}
  />,
  <Route
    key={NoAuthRouteKeys.CampaignLandingPage}
    path={NoAuthRouteKeys.CampaignLandingPage}
    element={<CampaignProgramPage />}
  />,
  <Route
    key={NoAuthRouteKeys.TradeDataLimitations}
    path={NoAuthRouteKeys.TradeDataLimitations}
    element={<TradeDataLimitationsPage />}
  />,
  <Route key={NoAuthRouteKeys.TradeData} path={NoAuthRouteKeys.TradeData} element={<TradeDataPublicPage />} />,
];

export default NoAuthRoutes;
